import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import { connect } from "react-redux";
import { deleteBank } from "../../../../domain/profile/profileActions";
import StatusMessage from "../../../presentational/StatusMessage";
import Confirm from "../../../presentational/Confirm/Confirm";
import styles from "./BankAccounts.module.less";
const messages = defineMessages({
    errorIntro: {
        id: "bankAccounts.errorIntro",
        defaultMessage: "Your saved bank account could not be deleted due to this error:"
    }
});
function getModalTriggerId(bankInfoId) {
    return bankInfoId == null ? undefined : `cancel-payment-${bankInfoId}`;
}
class BankAccountRow extends Component {
    constructor() {
        super(...arguments);
        this._handleDelete = () => {
            if (!this.props.isBusy) {
                this.props.onDelete(this.props.bankInfo.id);
            }
        };
    }
    render() {
        const { bankInfo, index, isBusy } = this.props;
        return (<li key={bankInfo.id} className="tableListRow">
				<h5 className="u-isVisuallyHidden">
					Bank Account {index + 1}
				</h5>
				<ol className="tableListRow-list">
					<li className="tableListRow-list-col tableListRow-list-col_l">
						<h6 className="u-isVisuallyHidden">
							<FormattedMessage id="bankAccounts.table.name" defaultMessage="Name"/>
						</h6>
						<p>{bankInfo.name}</p>
					</li>
					<li className="tableListRow-list-col tableListRow-list-col_m">
						<h6 className="u-isVisuallyHidden">
							<FormattedMessage id="bankAccounts.table.action" defaultMessage="Action"/>
						</h6>
						<p>
							<button type="button" className="link js-modal-btnTrigger" onClick={this._handleDelete} disabled={isBusy} data-modaltriggerid={getModalTriggerId(bankInfo.id)}>
								<FormattedMessage id="bankAccounts.delete" defaultMessage="Delete"/>
							</button>
						</p>
					</li>
				</ol>
			</li>);
    }
}
class BankAccounts extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            confirm: null,
            closedConfirm: null // for refocusing on modal triggerId
        };
        this._handleConfirm = (id) => {
            this.setState({
                confirm: id,
                closedConfirm: null
            });
        };
        this._closeConfirmModal = () => {
            this.setState(prevState => ({
                confirm: null,
                closedConfirm: prevState.confirm
            }));
        };
        this._handleConfirmOk = () => {
            this.props.onDelete(this.state.confirm);
            this._closeConfirmModal();
        };
    }
    render() {
        const { props, state } = this;
        const bankAccounts = props.profile == null ? [] : props.profile.bankAccounts;
        const confirmDeleteBankAccount = state.confirm == null ? null : bankAccounts.find(it => it.id === state.confirm);
        return (<div>
				<div className="vr vr_x2">
					<h2 className="hdg js-pageHeader">
						<FormattedMessage id="bankAccounts.header" defaultMessage="Bank Information"/>
					</h2>
				</div>

				<StatusMessage isError isActive={props.error != null} customMessage={messages.errorIntro} error={props.error}/>

				<div className="vr vr_x2">
					{bankAccounts.length === 0 && (<div className="text">
							<FormattedMessage tagName="p" id="bankAccounts.noAccounts" defaultMessage="No bank accounts are currently saved. Bank accounts can be added when making a payment."/>
						</div>)}

					{bankAccounts.length > 0 && (<div className="tableList">
							<div className="tableListRow">
								<ol className="tableListRow-list">
									<li className="tableListRow-list-col tableListRow-list-col_l mix-tableListRow-list-col_hdg">
										<FormattedMessage id="bankAccounts.table.name" defaultMessage="Name"/>
									</li>
									<li className="tableListRow-list-col tableListRow-list-col_m mix-tableListRow-list-col_hdg">
										<FormattedMessage id="bankAccounts.table.action" defaultMessage="Action"/>
									</li>
								</ol>
							</div>
							<ol>
								{props.profile.bankAccounts.map((bankInfo, index) => (<BankAccountRow key={bankInfo.id} bankInfo={bankInfo} index={index} {...props} onDelete={this._handleConfirm}/>))}
							</ol>
						</div>)}
				</div>

				<StatusMessage isLoad isActive={props.isBusy}/>

				<Confirm open={confirmDeleteBankAccount != null} onCancel={this._closeConfirmModal} onOk={this._handleConfirmOk} triggerId={getModalTriggerId(state.closedConfirm)}>
					{this._renderConfirm(confirmDeleteBankAccount)}
				</Confirm>
			</div>);
    }
    _renderConfirm(bankAccount) {
        if (bankAccount == null) {
            return null;
        }
        return (<div className="text">
				<FormattedMessage tagName="p" id="bankAccounts.confirm" defaultMessage="Are you sure you wish to delete {name}?" values={{
            name: (<strong className={styles.strong}>
								{bankAccount.name}
							</strong>)
        }}/>
				<p className="mix-text_small">
					<FormattedMessage id="bankAccounts.confirm.scheduledPayments" defaultMessage={" Note that any scheduled payments using this bank "
            + "information will continue to be processed. Scheduled "
            + "payments can be cancelled in the account details."}/>
				</p>
			</div>);
    }
}
export default connect((state) => ({
    profile: state.profile.profile,
    isBusy: state.profile.isDeletingBankAccount,
    error: state.profile.deleteBankAccountError
}), {
    onDelete: deleteBank
})(BankAccounts);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/BankAccounts/BankAccounts.tsx